import { lazy, Suspense } from 'react';
import { Spinner } from '@radix-ui/themes';
import AdKaoraBanner, { AdSlot } from 'ui/design-base/AdKaoraBanner';
import Page from 'ui/design-base/Page';

const PlayersAdvancedSearchContent = lazy(() => import('ui/design-base/PlayersAdvancedSearchContent'));

export const PlayersAdvancedSearchPage = () => {
  const pageTitle = 'Ricerca avanzata giocatori';
  return (
    <Page title={pageTitle} className='players-advanced-search-page' showAds={true}>
      <div className='my-5'>
        <AdKaoraBanner slot={AdSlot.ARTICLE_TOP} />
        <Suspense fallback={<Spinner />}>
          <PlayersAdvancedSearchContent />
        </Suspense>
      </div>
      <AdKaoraBanner slot={AdSlot.ARTICLE_BOTTOM} />
    </Page>
  );
};

export default PlayersAdvancedSearchPage;
